import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import AddMemberCard from './addMemberCard';
import ListMemberCard from './listMemberCard';
import { styles } from './styles';
import Header from '../../partials/header';

class MemberCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdd: false,
        } 
    }

    toggleNew = () => {
        this.setState(preState => ({isAdd: !preState.isAdd}))
    } 
    render() { 
        const { serviceBranchState, t } = this.props; 
        const {isAdd = false} = this.state;
        return (
            <React.Fragment> 
                {!isAdd ?
                    <React.Fragment>
                        <Header
                            session= {t('sidebar_promotion')}
                            title= {t('membercard_list_membercard')}
                            button= {t('membercard_add_new_membercard')}
                            actionButton={this.toggleNew}
                        /> 
                        <ListMemberCard onRef={list => this.mListMemberCard = list}/>
                    </React.Fragment>
                    : <React.Fragment>
                        <Header
                            session= {t('membercard_list_membercard')}
                            title= {t('membercard_add_new_membercard')} 
                            backIcon = {true} 
                            actionBack={()=>this.toggleNew()} 
                        />
                        <AddMemberCard createDone={this.toggleNew} serviceBranchState={serviceBranchState}/>
                    </React.Fragment> 
                }  
            </React.Fragment>
        );
    }
}

MemberCard.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const mapState = state => ({ 
    serviceBranchState: state.serviceBranch
});

const mapDispatch = dispatch => ({
    getList: dispatch.memberCards.getList,
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(MemberCard)));